module.exports = __webpack_public_path__ + "img/BG_header_machines.776f06eb.jpg";